import { useState } from "react";
import { useGestock } from "../../GestockContext";
import { useFournisseurs, useTerminalStocks } from "../../useOilmed";
import { useLots } from "./useLots";
import { useAllDedouanements } from "./useAllDedouanements";
import LotsList from "./LotsList";
import HistoriqueDedouanement from "./HistoriqueDedouanement";
import DedouanerModal from "./DedouanerModal";
import EntreeDouaneForm from "./EntreeDouaneForm";
import { fmt } from "../../utils";
import { isWithinRange } from "../../monthUtils";

export default function GSousDouane() {
  const { terminal, produit, monthRange } = useGestock();
  const { stocks, loading } = useTerminalStocks(terminal);
  const { lots, lotsLoading } = useLots(terminal, produit);
  const dedouanements = useAllDedouanements(terminal, produit, lots);
  const monthDedouanements = dedouanements.filter((d) =>
    isWithinRange(d.date || d.createdAt, monthRange),
  );

  const stock = stocks?.[produit];
  const dejaDD = stock ? (stock.sd_init || 0) - (stock.sd || 0) : 0;
  const prodLabel = produit === "essence" ? "Super" : "Go";

  // Stock sous douane par fournisseur (fournisseur du lot) : une carte par
  // fournisseur de la liste, + ceux trouvés sur les lots.
  const { liste: fournisseurs, couleur: couleurFournisseur } = useFournisseurs(terminal);
  const parFournisseur = {};
  for (const f of fournisseurs) parFournisseur[f] = { sd: 0, dd: 0 };
  for (const lot of lots || []) {
    const f = String(lot.fournisseur || "").trim().toUpperCase() || "Non attribué";
    parFournisseur[f] = parFournisseur[f] || { sd: 0, dd: 0 };
    parFournisseur[f].sd += lot.volumeM3 || 0;
    parFournisseur[f].dd += (lot.volumeM3_initial || 0) - (lot.volumeM3 || 0);
  }
  // Du plus grand stock sous douane au plus petit
  const cartesFournisseurs = Object.entries(parFournisseur).sort(
    ([, a], [, b]) => b.sd - a.sd,
  );

  const [showModal, setShowModal] = useState(false);
  const [showEntreeForm, setShowEntreeForm] = useState(false);

  return (
    <div className="fade-up">
      <div className="page-header">
        <div className="page-title">
          Sous <span>Douane</span>
        </div>
        <div className="page-sub">
          {"// "}
          {terminal} · {prodLabel.toUpperCase()} — STOCK BLOQUÉ
        </div>
      </div>

      {/* KPI Cards */}
      <div className="kpi-grid">
        {cartesFournisseurs.length > 0 ? (
          cartesFournisseurs.map(([f, v]) => (
            <div
              key={f}
              className="kpi-card"
              style={{ "--kpi-color": f === "Non attribué" ? "var(--gold)" : couleurFournisseur(f) }}
            >
              <div className="kpi-label">{f}</div>
              <div className="kpi-value">{lotsLoading ? "…" : fmt(v.sd)}</div>
              <div className="kpi-unit">
                m³ sous douane
                {!lotsLoading && v.dd > 0.0005 && ` · ${fmt(v.dd)} m³ dédouanés`}
              </div>
            </div>
          ))
        ) : (
          <>
            <div className="kpi-card" style={{ "--kpi-color": "var(--gold)" }}>
              <div className="kpi-label">Restant sous douane</div>
              <div className="kpi-value">{loading ? "…" : fmt(stock?.sd)}</div>
              <div className="kpi-unit">m³ bloqués</div>
            </div>
            <div className="kpi-card" style={{ "--kpi-color": "var(--green)" }}>
              <div className="kpi-label">Déjà dédouanés</div>
              <div className="kpi-value">{loading ? "…" : fmt(dejaDD)}</div>
              <div className="kpi-unit">m³ transférés</div>
            </div>
          </>
        )}
      </div>

      {/* Entrée Douane Button */}
      <button
        className="btn btn-blue btn-full"
        style={{ marginBottom: 14 }}
        onClick={() => {
          console.log("[GSousDouane] Entrée Douane button clicked");
          setShowEntreeForm(true);
        }}
      >
        ＋ Entrée Douane
      </button>

      {/* Dédouaner Button */}
      <button
        className="btn btn-gold btn-full"
        style={{ marginBottom: 14 }}
        onClick={() => setShowModal(true)}
      >
        ⇒ Dédouaner une partie
      </button>

      {/* Lots List */}
      <LotsList lots={lots} lotsLoading={lotsLoading} />

      {/* Historique dédouanements */}
      <HistoriqueDedouanement rows={monthDedouanements} monthRange={monthRange} />

      {/* Dédouaner Modal */}
      <DedouanerModal
        showModal={showModal}
        setShowModal={setShowModal}
        stock={stock}
        terminal={terminal}
        produit={produit}
      />

      {/* Entrée Douane Form */}
      <EntreeDouaneForm
        showForm={showEntreeForm}
        setShowForm={setShowEntreeForm}
        terminal={terminal}
        produit={produit}
      />
    </div>
  );
}
